<template>
  <div>
    <Button
      v-if="revOptions.length <= 1"
      color="primary"
      data-tourid="stream-button-create-rev"
      data-testid="revstream-create-rev"
      :text="$t('common.create_rev')"
      @click="
        revOptions.length < 1
          ? openCreateRevModal('quickAction')
          : openCreateRevModal(revOptions[0].id)
      "
    />

    <v-menu v-else offset-y bottom left>
      <template v-slot:activator="{ on }">
        <Button
          color="primary"
          data-tourid="stream-button-create-rev"
          data-testid="revstream-create-rev"
          :disabled="disabled"
          :text="$t('common.create_rev')"
          v-on="on"
        />
      </template>
      <v-list dense nav class="px-0">
        <v-list-item
          v-for="(option, index) in revOptions"
          :key="index"
          :data-tourid="option.tid"
          :data-testid="option.tid"
          @click="openCreateRevModal(option.id)"
          :class="`${option.id}-colors`"
        >
          <v-list-item-content class="mx-2">
            <v-list-item-title>
              <v-icon color="blue-grey-darken-2">{{ option.icon }}</v-icon>
              {{ option.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <CreateRevModalByType
      v-if="revType"
      :challengeId="challengeId"
      :show="showCreateRev"
      :type="revType"
      @close="showCreateRev = false"
      @created="showCreateRev = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import CreateRevModalByType from '@/components/CreateRevModalByType/CreateRevModalByType.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'CreateRevButton',

  components: {
    Button,
    CreateRevModalByType,
  },

  props: {
    challengeId: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
  },

  data() {
    return {
      showCreateRevOptionsPopover: false,
      showCreateRev: false,
      revType: null,
    }
  },

  computed: {
    ...mapGetters(['organization']),

    revOptions() {
      const options = []
      if (this.organization.featuresEnabled__improvementIdea) {
        options.push({
          id: this.$constants.revTypes.improvementIdea,
          text:
            this.organization.customNamings['improvementIdea']?.singular ||
            this.$t('common.improvement_idea_one'),
          tid: 'improvementIdea-dropdown-create',
          icon: 'mdi-lightbulb-outline',
        })
      }

      if (this.organization.featuresEnabled__problemSolving) {
        options.push({
          id: 'problemSolving',
          text:
            this.organization.customNamings['problemSolving']?.singular ||
            this.$t('common.problem_solving_one'),
          tid: 'problemSolving-dropdown-create',
          icon: 'mdi-puzzle-outline',
        })
      }

      if (this.organization.featuresEnabled__quickAction) {
        options.push({
          id: 'quickAction',
          text:
            this.organization.customNamings['quickAction']?.singular ||
            this.$t('common.quick_action_one'),
          tid: 'quickAction-dropdown-create',
          icon: 'mdi-lightning-bolt-outline',
        })
      }

      return options
    },
  },

  methods: {
    openCreateRevModal(revType) {
      this.revType = revType
      this.showCreateRev = true
    },
  },
}
</script>

<style lang="scss" scoped>
.quickAction-colors {
  &:hover {
    box-shadow: inset 4px 0 0 0 $color-yellow;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.problemSolving-colors {
  &:hover {
    box-shadow: inset 4px 0 0 0 $color-blue;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.improvementIdea-colors {
  &:hover {
    box-shadow: inset 4px 0 0 0 $color-purple;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
</style>
